import styled from 'styled-components';

import { ModalBody, Modal } from 'ui/modal';
import { FormField } from 'ui/formField';
import { fontSizes, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const FieldRow = styled.div`
  display: flex;
  column-gap: ${pxToRem(14)};
  > *:first-child {
    flex: 1 1 auto;
    margin-top: ${spacing.plusHalf};
  }
  > *:not(:first-child) {
    flex: 0 0 auto;
  }
`;

export const StyledModal = styled(Modal)`
  overflow: visible;
`;

export const StyledModalBody = styled(ModalBody)`
  overflow: visible;
  padding: 0 ${spacing.plusHalf} ${spacing.plusHalf};
`;

export const StyledModalSubheader = styled(ModalBody)`
  border: none;
  font-size: ${fontSizes.s14};
  padding: 0 ${spacing.plusHalf} ${spacing.plusHalf};
`;

export const ScrollableModalBody = styled(StyledModalBody)`
  max-height: calc(100vh - ${spacing.x24});
  overflow: auto;
`;

export const StyledFormField = styled(FormField)`
  margin: ${spacing.plusHalf} 0;

  & > * {
    margin-right: ${spacing.quarter};
  }
`;
